import React, { useState } from "react";
import { Panel, PageLoading, PanelActions, PanelHeading, Button } from "@backslashbuild/pp-ui";
import FormField from "./FormField";
import { usePost, useGetNewFields } from "./api";
import { isTextNullOrEmpty } from "./utils";

export default function AddAWSPromoCodeForm({ id, onClose }) {
  const [payload, storePayload] = useState({});
  const { data, loading, error } = useGetNewFields({
    contractorId: id,
    formName: `contractor-anytimeWagePromotionalCode`,
  });
  const createAWSPromoCode = usePost("contractor-anytimeWagePromotionalCodes/create");

  if (loading) return <PageLoading />;

  function handleRender() {
    if (!isTextNullOrEmpty(error)) return <div>{String(error)}</div>;

    if (data != null && !data.isSuccess) {
      return data.errors.map((error) => <div>{error}</div>);
    }

    return data.value.map((field) => (
      <FormField key={field.key} field={field} onSave={getOnSaveHandler(field.key)} />
    ));
  }

  function getOnSaveHandler(key) {
    return (value) => {
      storePayload({ ...payload, [key]: value });
    };
  }

  return (
    <Panel>
      <PanelHeading>Add promotional code</PanelHeading>
      {handleRender()}
      <PanelActions>
        <Button variant="secondary" onClick={() => onClose()}>
          Cancel
        </Button>
        <Button
          onClick={() => {
            createAWSPromoCode({
              contractorId: id,
              ...payload,
            });
            onClose();
          }}
        >
          Save
        </Button>
      </PanelActions>
    </Panel>
  );
}
